var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7C16.5 6.07003 16.5 5.60504 16.3978 5.22354C16.1204 4.18827 15.3117 3.37962 14.2765 3.10222C13.895 3 13.43 3 12.5 3C11.57 3 11.105 3 10.7235 3.10222C9.68827 3.37962 8.87962 4.18827 8.60222 5.22354C8.5 5.60504 8.5 6.07003 8.5 7M13.3 17.5H18.2C18.48 17.5 18.62 17.5 18.727 17.4455C18.8211 17.3976 18.8976 17.3211 18.9455 17.227C19 17.12 19 16.98 19 16.7V14.3C19 14.02 19 13.88 18.9455 13.773C18.8976 13.6789 18.8211 13.6024 18.727 13.5545C18.62 13.5 18.48 13.5 18.2 13.5H13.3C13.02 13.5 12.88 13.5 12.773 13.5545C12.6789 13.6024 12.6024 13.6789 12.5545 13.773C12.5 13.88 12.5 14.02 12.5 14.3V16.7C12.5 16.98 12.5 17.12 12.5545 17.227C12.6024 17.3211 12.6789 17.3976 12.773 17.4455C12.88 17.5 13.02 17.5 13.3 17.5ZM7.3 21H17.7C19.3802 21 20.2202 21 20.862 20.673C21.4265 20.3854 21.8854 19.9265 22.173 19.362C22.5 18.7202 22.5 17.8802 22.5 16.2V11.8C22.5 10.1198 22.5 9.27976 22.173 8.63803C21.8854 8.07354 21.4265 7.6146 20.862 7.32698C20.2202 7 19.3802 7 17.7 7H7.3C5.61984 7 4.77976 7 4.13803 7.32698C3.57354 7.6146 3.1146 8.07354 2.82698 8.63803C2.5 9.27976 2.5 10.1198 2.5 11.8V16.2C2.5 17.8802 2.5 18.7202 2.82698 19.362C3.1146 19.9265 3.57354 20.3854 4.13803 20.673C4.77976 21 5.61984 21 7.3 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersIcon);
export default __webpack_public_path__ + "static/media/careers-icon.7ec5d556a218aec89acc996383309006.svg";
export { ForwardRef as ReactComponent };